import { useState } from "react";
import { Checkbox, Modal } from "antd";
import { useLocation } from "react-router-dom";

import Button from "../../../ui/Button";
import styles from "./SortModal.module.css";
import { parse, stringify } from "query-string";
import { useLangNavigate } from "../../../../../hooks/useLangNavigate";

const SortModal = (props) => {
  const {
    sort_modal,
    set_sort_modal,
    active_sort,
    set_active_sort,
    sort_list,
  } = props;

  const location = useLocation();
  const navigate = useLangNavigate();
  const parsed_query = parse(location.search);
  const [pre_active, set_pre_active] = useState(active_sort);

  const sort_pre_handel = (sortItem) => {
    set_pre_active(sortItem.value);
    const new_queries = { ...parsed_query };
    new_queries.sort = `${sortItem?.field}-${sortItem?.direction}`;
    Object.keys(new_queries).forEach((query_key) => {
      if (query_key !== "sort" && query_key !== "level") {
        new_queries[query_key] = new_queries[query_key].split(",");
      }
    });
    const new_url = `${location.pathname}?${stringify(new_queries, {
      arrayFormat: "comma",
    })}`;
    navigate(new_url);
  };

  // useEffect(() => {
  //     if (sort_modal) {
  //         set_pre_active([active_sort]);
  //     }
  //     // eslint-disable-next-line
  // }, [sort_modal]);

  const submit_click = () => {
    set_active_sort(pre_active);
    set_sort_modal(false);
  };

  return (
    <Modal
      open={sort_modal}
      footer={null}
      className={styles.SortModal}
      bodyStyle={{
        paddingTop: "30px",
      }}
      onCancel={() => set_sort_modal(false)}
    >
      <div className={styles.SortModalContainer}>
        {sort_list.map((sortItem) => {
          return (
            <Checkbox
              checked={pre_active === sortItem.value}
              className={styles.CheckboxStyle}
              onChange={() => sort_pre_handel(sortItem)}
              onClick={() => sort_pre_handel(sortItem)}
            >
              {sortItem.label}
            </Checkbox>
          );
        })}
        <div className="w-full flex center-content mt-4">
          <Button style_width={"80%"} onClick={submit_click}>
            Sort
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SortModal;
